<template>
  <b-modal :id="id" @close="clean" @hidden="clean" @ok="confirm" :title="title" :ok-title="button" header-bg-variant="dark" header-text-variant="light" ok-variant="dark">
    <b-form ref="project_form">
      <b-form-group description="Название проекта" :invalid-feedback="invalidName">
        <b-form-input v-model="name" type="text" placeholder="Название" :state="nameState" maxlength="100" required/>
      </b-form-group>
      <b-form-group description="Описание проекта" :invalid-feedback="invalidDescription">
        <b-form-textarea v-model="description" placeholder="Описание" :state="descriptionState" maxlength="300" required/>
      </b-form-group>
      <b-form-group description="Теги">
        <b-form-tags no-outer-focus v-model="tags" placeholder="" remove-on-delete size="md" tag-variant="dark"/>
      </b-form-group>
      <b-form-group>
        <label class="d-block mb-1 font-weight-bold" style="color: var(--text-foreground);">Агенты для сканирования</label>
        <p class="text-muted small mb-2">Выберите агентов, которые будут выполнять задачи сканирования целей этого проекта</p>
        <div v-if="agentList.length === 0" class="text-muted small py-2">
          Агенты не найдены. Создайте агента на вкладке «Агенты».
        </div>
        <div v-else class="agent-checkbox-list" style="max-height: 200px; overflow-y: auto; border: 1px solid var(--border-default); border-radius: 6px; padding: 8px;">
          <b-form-checkbox
            v-for="agent in agentList"
            :key="agent.id"
            :value="agent.id"
            v-model="selectedAgents"
            class="mb-1"
            :inline="false"
          >
            <span class="font-weight-bold" style="color: var(--text-foreground);">{{ agent.name }}</span>
            <b-badge :variant="agent.status === 'online' ? 'success' : 'danger'" class="ml-2" style="font-size: 0.7rem;">
              {{ agent.status === 'online' ? 'в сети' : 'не в сети' }}
            </b-badge>
            <span v-if="agent.hostname" class="text-muted small ml-1">— {{ agent.hostname }}</span>
          </b-form-checkbox>
        </div>
        <p v-if="selectedAgents.length === 0 && agentList.length > 0" class="text-warning small mt-1 mb-0">
          ⚠ Если не выбран ни один агент, задачи будут выполняться локально на сервере
        </p>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'projectModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    project: Object,
    initialized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    edit () {
      return (this.project !== null)
    },
    title () {
      return this.project !== null ? 'Редактировать проект' : 'Новый проект'
    },
    button () {
      return this.project !== null ? 'Обновить проект' : 'Создать проект'
    }
  },
  data () {
    return {
      name: null,
      description: null,
      tags: [],
      selectedAgents: [],
      agentList: [],
      nameState: null,
      descriptionState: null,
      invalidName: 'Название проекта обязательно',
      invalidDescription: 'Описание проекта обязательно'
    }
  },
  created () {
    this.loadAgents()
  },
  watch: {
    initialized (initialized) {
      if (initialized && this.project) {
        this.name = this.project.name
        this.description = this.project.description
        this.tags = this.project.tags
        this.selectedAgents = (this.project.agents || []).map(a => a.id)
      }
    }
  },
  methods: {
    check () {
      const valid = this.$refs.project_form.checkValidity()
      if (!this.validateName(this.name)) {
        this.nameState = false
        this.invalidName = this.name && this.name.length > 0 ? 'Неверное название проекта' : 'Название проекта обязательно'
      }
      if (!this.validateText(this.description)) {
        this.descriptionState = false
        this.invalidDescription = this.description && this.description.length > 0 ? 'Неверное описание' : 'Описание проекта обязательно'
      }
      return valid && this.nameState !== false && this.descriptionState !== false
    },
    confirm (event) {
      event.preventDefault()
      if (this.check()) {
        const operation = this.edit ? this.update() : this.create()
        operation.then(success => this.$emit('confirm', { id: this.id, success: success, reload: true }))
      }
    },
    loadAgents () {
      this.get('/api/agents/')
        .then(response => {
          this.agentList = response.data.results
        })
        .catch(() => { this.agentList = [] })
    },
    create () {
      return this.post(
        '/api/projects/',
        { name: this.name, description: this.description, tags: this.tags, agent_ids: this.selectedAgents },
        this.name , 'Новый проект создан успешно'
      )
        .then(() => { return Promise.resolve(true) })
        .catch(() => { return Promise.resolve(false) })
    },
    update () {
      return this.put(
        `/api/projects/${this.project.id}/`,
        { name: this.name, description: this.description, tags: this.tags, agent_ids: this.selectedAgents },
        this.name , 'Проект обновлён успешно'
      )
        .then(() => { return Promise.resolve(true) })
        .catch(() => { return Promise.resolve(false) })
    },
    clean () {
      this.name = null
      this.description = null
      this.tags = []
      this.selectedAgents = []
      this.nameState = null
      this.descriptionState = null
      this.$emit('clean')
    }
  }
}
</script>